module.exports = __webpack_public_path__ + "static/media/job-seerkers-bg.66a6e773.png";